import { useTranslation } from "react-i18next";

import { showActionAlert } from "@components/molecules/alert";
import { useNotifyPromise } from "@hooks";
import { useAcceptAppointment } from "@api/appointment";
import type { ID } from "@constants";

export const useAcceptAppointmentFunc = (id: ID) => {
  const { t } = useTranslation("form");

  const notifyMutate = useNotifyPromise();
  const { mutateAsync } = useAcceptAppointment();

  return () =>
    showActionAlert({
      title: t("accept_appointment"),
      content: t("accept_appointment_text"),
      onApprove: async () => {
        await notifyMutate(mutateAsync({ appointmentId: id }));
      },
      approveTitle: t("accept_appointment"),
    });
};
